exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-image{height:35px;width:35px;-o-object-fit:cover;object-fit:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:var(--text-white);border-radius:50%;overflow:hidden}.profile-image-bg{background-color:#383838}html[data-theme=dark] .profile-image-bg{background-color:var(--primary)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-160b2aaf","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/misc/userImage.vue
// module id = WqzF
// module chunks = 11 18 32